import React, { FC } from 'react';
import Form from 'components/Form';

import { WoolitePageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Woolite: FC<WoolitePageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Woolite;
